import { graphql } from '../../../graphql/generated';

export const FORMS_QUERY = graphql(`
  query Forms($labId: ID!) {
    labForms(labId: $labId) {
      id
      name
      header
      description
      pickup
      printBeforeSend
      printRequired
      printCopies
      hasDocument
      direct
      restore
      requiredByFrontDesk
      doctors {
        id
      }
      fields {
        id
        name
        label
        placeholder
        required
        help
        defaultValue
        regex
        type
        options {
          label
          value
          selected
        }
      }
    }

    doctors {
      id
      name
      meAddress
      firstName
      lastName
      salutation
      preTitle
      postTitle
      disabled
    }
  }
`);
